/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/Policies" />
import React = require("react");
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { getPoliciesViewService } from "../Services/PoliciesViewService";
import { BranchPolicies } from "./BranchPolicies";
import { RepoPolicies } from "./RepoPolicies";

interface IPoliciesProps {
    goToProject: () => void;
    goToRef?: (ref: string, repositoryId?: string) => void;
    refName?: string;
    repositoryId?: string;
    repositoryName?: string;
}

export class Policies extends VssComponent<IPoliciesProps> {
    constructor(props: IPoliciesProps, context: IVssComponentContext) {
        super(props, context);

        getPoliciesViewService(context.pageContext).setSettingsContext(props);
    }

    public componentDidUpdate(props: IPoliciesProps) {
        // This is not ideal, but we're avoiding a dependency between services and instead relying on props
        getPoliciesViewService(this.context.pageContext).setSettingsContext(props);
    }

    public render = (): JSX.Element => {
        if (this.props.refName) {
            return <BranchPolicies goToProject={this.props.goToProject} goToRef={this.props.goToRef} />;
        }

        return <RepoPolicies goToProject={this.props.goToProject} />;
    };
}

Components.add("ms.vss-code-web.repositories-policies-component", Policies);
